import React, { useMemo } from 'react';
import cn from 'classnames';
import { useResearchContext } from '@/finsight/application/Research/ResearchContext';
import DataTable, { dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';
import getTableColumns from './columns';

import styles from './researchTable.scss';

function ResearchTable() {
  const {
    researchData: {
      collection,
      sortBy,
      sortOrder,
    },
    sort,
    getResearchList,
  } = useResearchContext();
  const { getDocumentById } = useResearchContext();
  const tableColumns = useMemo(
    () => getTableColumns(getDocumentById),
    [getDocumentById],
  );

  const handleSortChange = (sortBy, sortOrder) => {
    sort(sortBy, sortOrder);
    getResearchList({
      sortBy,
      sortOrder,
    });
  };

  return (
    <DataTable
      className={ cn(styles.researchTable, dataTableStyles.isHoverable) }
      dataTest="researchDataTable"
      columns={ tableColumns }
      data={ collection }
      sortBy={ sortBy }
      sortOrder={ sortOrder }
      onSortChange={ handleSortChange }
    />
  );
}

export default ResearchTable;
